import { Button } from '@mui/material';
import { ArrowBackIosNewRounded } from '@mui/icons-material';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';

export const ButtonBackMobile = withRouter(({ title, icon, children, variant, size, ...props }) => {
  return (
    <Button
      variant={variant || 'text'}
      color='secondary'
      size={size || 'small'}
      startIcon={icon || <ArrowBackIosNewRounded />}
      onClick={props.onClick || props.history.goBack}
      sx={{ mb: 1, fontWeight: 'bold', textTransform: 'none', px: 0, justifyContent: 'flex-start' }}
      aria-label={`Volver a ${title || 'la página anterior'}`}
    >
      {children || title || 'Atrás'}
    </Button>
  );
});
